var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100"},[_c('div',{staticClass:"scroll-wrapper",staticStyle:{"top":"0.1rem"}},[_c('iframe',{ref:"mainContent",attrs:{"frameborder":"0","src":_vm.url,"width":"100%","height":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }